// extracted by mini-css-extract-plugin
export default {"sharedControls":"sharedControls__ld80Ju","form":"form__QX4uHS","tabContent":"tabContent__h_yVWc"};